module.exports = __webpack_public_path__ + "img/联系我们底图.4b7b8787.png";